import React from 'react';

interface LogoProps {
  className?: string;
}

const Logo = ({ className = "" }: LogoProps) => (
  <img
    src="https://res.cloudinary.com/dansvy9a5/image/upload/v1739131537/logo_no_font_ifjznq.png"
    alt="AURA IMMERSION – Curated transformative experiences in Mauritius for independent women seeking growth and renewal"
    className={`h-32 w-auto ${className}`}
  />
);

export default Logo;